import React from "react";
import { useParams } from "react-router-dom";
import CategoryDesignPurchasePage from "./Category/ProductPage/CategoryDesignPurchasePage";
import CollectionCategoryPurchase from "./Collection/CollectionCategoryPurchase";
import CollectionDesignPurchasePage from "./Collection/ProductPage/CollectionDesignPurchasePage";

function PurchaseSubCategoryPageWrapper() {
  const { purchase, category, subCategory } = useParams();

  const decodedCategory = decodeURIComponent(category);
  const decodedSubCategory = decodeURIComponent(subCategory);

  const renderCategoryProductPage = () => {
    switch (purchase) {
      case "Category-Purchased":
        return <CategoryDesignPurchasePage category={decodedCategory} subCategory={decodedSubCategory} />;

      case "Collection-Purchased":
        return <CollectionDesignPurchasePage collection={decodedCategory} category={decodedSubCategory} />;

      default:
        return <div style={{ color: "gray" }}>No matching category component for {purchase}</div>;
    }
  };

  return <>{renderCategoryProductPage()}</>;
}

export default PurchaseSubCategoryPageWrapper;
